import { render, staticRenderFns } from "./StepDestinataire.vue?vue&type=template&id=181e2dd4&scoped=true"
import script from "./StepDestinataire.vue?vue&type=script&lang=js"
export * from "./StepDestinataire.vue?vue&type=script&lang=js"
import style0 from "./StepDestinataire.vue?vue&type=style&index=0&id=181e2dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e2dd4",
  null
  
)

export default component.exports